module.exports = __webpack_public_path__ + "img/1559237746.12f452b2.jpg";